import { isAuthenticated } from '@/auth';
import Vue from 'vue';
import VueRouter from 'vue-router';
import lazy from './lazy';

Vue.use(VueRouter)


const router = new VueRouter({
  routes: [
    {
      path: '/login',
      component: lazy('login/Layout'),
      name: 'login'
    },
    {
      path: '/',
      component: lazy('home/Layout'),
      name: 'home',
      meta: { requiresAuth: true }
    },
    {
      path: '/comparator',
      component: lazy('Comparator.vue'),
      name: 'comparator',
      meta: { requiresAuth: true }
    },
    {
      path: '/classifier',
      name: 'classifier',
      component: lazy('classifier/Layout.vue'),
      redirect: { name: 'classifier/sellers' },
      meta: { requiresAuth: true },
      children: [
        {
          path: 'sellers',
          name: 'classifier/sellers',
          component: lazy('classifier/content/sellers/Layout.vue')
        },
        {
          path: 'sellers/:classificationsSellerId',
          component: lazy('classifier/content/seller-context/Layout.vue'),
          name: 'classifier/sellers-context',
          redirect: { name: 'classifier/classifications' },
          children: [
            {
              path: 'classifications',
              name: 'classifier/classifications',
              component: lazy('classifier/content/seller-context/classifications/Layout.vue')
            },
            {
              path: 'classifications/:classificationId',
              name: 'classifier/predictions',
              redirect: { name: 'classifier/predictions/items' },
              component: lazy('classifier/content/seller-context/predictions/Layout.vue'),
              children: [
                {
                  path: 'categories',
                  name: 'classifier/predictions/categories',
                  component: lazy('classifier/content/seller-context/predictions/categories/Layout.vue')
                },
                {
                  path: 'items',
                  name: 'classifier/predictions/items',
                  component: lazy('classifier/content/seller-context/predictions/items/Layout.vue')
                },
                {
                  path: 'items/validated',
                  name: 'classifier/predictions/validated',
                  component: lazy('classifier/content/seller-context/predictions/items/validated/Layout.vue')
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/matching',
      component: lazy('matching/Layout'),
      name: 'matching',
      redirect: { name: 'matching/classifications' },
      meta: { requiresAuth: true },
      children: [
        {
          path: 'classifications',
          component: lazy('matching/content/classifications/Layout.vue'),
          name: 'matching/classifications'
        },
        {
          path: 'classifications/:classificationId/brands',
          component: lazy('matching/content/brands/Layout.vue'),
          name: 'matching/brands'
        },
        {
          path: 'classifications/:classificationId/brands/:brandName/pivots',
          name: 'matching/pivots',
          component: lazy('matching/content/pivots/Layout.vue')
        },
        {
          path: 'classifications/:classificationId/brands/:brandName/qmps',
          name: 'matching/qmps',
          component: lazy('matching/content/qmps/Layout.vue')
        }
      ]
    },
    {
      path: '/tagged-features',
      component: lazy('tagged-features/Layout.vue'),
      name: 'taggedFeatures',
      meta: { requiresAuth: true }
    },
    {
      path: '/value-mapping',
      component: lazy('value-mapping/Layout.vue'),
      redirect: { name: 'valueMapping' },
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'valueMapping'
        },
        {
          path: 'classifications/:classificationId',
          name: 'valueMapping/classification',
          /* A naive component to render the child component */
          component: {
            name: 'ClassificationsRouterView',
            render: c => c('router-view')
          },
          children: [
            {
              path: 'features/:featureId',
              name: 'valueMapping/classification/feature',
              component: lazy('value-mapping/content/Layout.vue')
            }
          ]
        }
      ]
    },
    {
      path: '/feature-rules',
      component: lazy('feature-rules/Layout.vue'),
      name: 'featureRules',
      meta: { requiresAuth: true }
    }
  ]
})


/**
 * Verify that the route where the user wants to go to does not requires authentication
 * or that the user is already authenticated. 
 */
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated()) {
    return next({ name: 'login', query: { next: to.name } })
  }

  return next()
})

export default router
